<div class="bodycontent">
    <div class="subheader with-padding flgrow">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-8" *ngIf="dealerList && dealerList.length > 0;">
                <div class="relative flmid">
                    <div class="flgrow">
                        <app-dealer-searchbox-dropdown [dealerList]="dealerList" [selectedDealer]="dealerSelected"
                            ngDefaultControl name="dealerDropdown" (onSelectDealer)="onDealerSelected($event)"
                            placeholder="Search Dealer">
                        </app-dealer-searchbox-dropdown>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-8">
                <div class="relative flmid">
                    <div class="flgrow">
                        <select class="form-control" [(ngModel)]="selecteMechanic"
                            (change)="selectedMechanic($event.target.value)">
                            <option selected [value]="0" disabled translate>lblSelectMechanic</option>
                            <option *ngFor="let mechanic of mechanicList" [(ngValue)]="mechanic.id">
                                {{mechanic.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container prel" *ngIf="isMechanicSelected">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-row">
                            <div class="col-md-3 col-lg-3">
                                <label translate>lblShiftForTheDay</label>{{mechanicShift}}
                            </div>
                            <div class="col-md-5 col-lg-6 text-center">
                                <div class="row mb-5 justify-content-center align-items-center">
                                    <button type="button" class="btn btn-outline-primary" (click)="getPreviousDate()">
                                        <em class="fas fa-arrow-left fa-lg"></em>
                                    </button>
                                    <div class="lbl-info date">
                                        <input class="card-header text-center datePicker width100force" appAfDatepicker
                                            [startDate]="'2011/01/01'" [format]="'D, d M Y'" readonly [dateTime]="false"
                                            [ngModelOptions]="{standalone: true}" [ngModel]="showDate"
                                            [endDate]="endDate" (OnSelect)="onChangeDate($event)">
                                    </div>
                                    <button type="button" class="btn btn-outline-primary" (click)="getNextDate()">
                                        <em class="fas fa-arrow-right fa-lg"></em>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 text-right">
                                <a class="mr-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefreshClick()" aria-label="Center Align">
                                    <em class="fas fa-sync fa-lg"></em>
                                </a>
                                <button class="btn btn-primary rounded-pill" aria-label="Center Align" type="button"
                                    (click)="todaysData()" translate>
                                    <em class="left"></em>lblToday
                                </button>
                                <button class="btn btn-primary rounded-pill ml-2" aria-label="Center Align"
                                    type="button" (click)="ViewSummaryClick(content)" translate>
                                    <em class="left"></em>lblViewSummary
                                </button>
                            </div>
                        </div>
                        <div class="center mb35">
                            <div class="innerdivstampbtn"
                                [ngClass]="userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd? '' :  'disable'">
                                <div class="flmidall row">
                                    <button class="cmnbigbtn btnbiggreen" type="button" aria-label="Center Align"
                                        (click)="stampInClick()" [disabled]="!stampInButton"
                                        translate>lblStampInFortheDay</button>
                                    <button class="cmnbigbtn btnbigred mt-3 mt-lg-0" aria-label="Center Align"
                                        type="button" (click)="stampOutClick()" [disabled]="!stampOutButton"
                                        translate>lblStampOutFortheDay</button>
                                </div>
                                <div class="flmidall row mt15">
                                    <button class="cmnbigbtn btnbiggrey button-overtime button-overtime-in"
                                        aria-label="Center Align" type="button" (click)="stampInForOverTimeClick()"
                                        [disabled]="!stampInOverTimeButton" translate>lblStampInForOvertime</button>
                                    <button
                                        class="cmnbigbtn btnbiggrey button-overtime button-overtime-out mt-3 mt-lg-0"
                                        aria-label="Center Align" type="button" (click)="stampOutForOverTimeClick()"
                                        [disabled]="!stampOutOverTimeButton" translate>lblStampOutForOvertime</button>
                                </div>
                                <div class="flmidall row mt15" *ngFor="let item of mechanicStampInOutDetails;let i = index">
                                    <div class="cmncontent">
                                        <div class="d-flex align-items-center justify-content-center mt-2">
                                            <ng-container *ngIf="item.stampIn">
                                                <span *ngIf="item.stampIn">{{item.stampIn | date:'short'}} </span>
                                                &nbsp; <button class="btn btn-gray" aria-label="Center Align" type="button"
                                                (click)="stampIn(item)">{{item.comment}} in</button>
                                                <input *ngIf="item.inTimePicker" type="text" appAfDatepicker
                                                    [dateTime]="false" id="stampInDate" [startDate]="stampStartDate"
                                                    [endDate]="stampEndDate" [ngModel]="stampInDate"
                                                    (OnSelect)="onChangeInTimeHours($event)" [format]="'d.m.Y'"
                                                    class="form-control DateInput ml-1" readonly hidden/>
                                                <input *ngIf="item.inTimePicker"
                                                    type="text" appAfDatepicker
                                                    [startDate]="'2011/01/01'"  [dateTime]="false" [isOnlyTime]="true" id="stampInDate"
                                                    class="form-control TimeInput mx-1" readonly
                                                    (hoursMinuteOutput)="onChangeInTimeHours(item, $event)" />
                                                <em *ngIf="item.inTimePicker"
                                                    class="far fa-clock fa-lg cursordisable"></em>
                                        </ng-container>
                                        </div>
                                    </div>
                                    <div class="cmncontent ">
                                        <div class="d-flex align-items-center justify-content-center mt-2">
                                            <ng-container>
                                                <span *ngIf="item.stampOut">{{item.stampOut | date:'short'}} </span>
                                                <button class="btn btn-gray" aria-label="Center Align" type="button" (click)="stampOut(item)">{{item.comment}}
                                                    out</button>
                                                <input *ngIf="item.timePicker" type="text" appAfDatepicker [dateTime]="false" id="stampOutDate"
                                                    [startDate]="stampStartDate"  [ngModel]="stampOutDate" [endDate]="today"
                                                    (OnSelect)="onChangeStampOutDate($event)" [format]="'d.m.Y'" class="form-control DateInput ml-1" readonly />
                                                <input *ngIf="item.timePicker" type="text" appAfDatepicker [dateTime]="false" [isOnlyTime]="true" id="stampOutTime"
                                                    class="form-control TimeInput mx-1" readonly (hoursMinuteOutput)="onChangeOpeningHours(item, $event)" />
                                                <em *ngIf="item.timePicker" class="far fa-clock fa-lg cursordisable"></em>
                                            </ng-container>
                                        </div>
                                        <span *ngIf="!item.isNormalOut && !isToday"
                                            style="color: red; line-height: normal;"
                                            translate>lblMechanicForgetCheckOut</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card crd boxst4 mb-5">
                            <div *ngIf="isToday && !(stampOutButton || stampOutOverTimeButton)" class="form-row text-info p-2 d-flex align-items-center">
                                <em class="fas fa-info-circle fa-lg align-middle"
                                    style="vertical-align: middle;"></em>
                                <span translate class="ml-2 mr-2 " style="font-size: 14px;">lblTimeCodeLabel</span>
                            </div>
                            <div class="row">
                                <div class="col-4 col-lg-2">
                                    <div class="row">
                                        <div class="col">
                                            <label translate>lblAssignedWork</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="">
                                                <div class="flgrow" *ngIf="assignedWork!=null">
                                                    <input type="text" class="form-control" [(ngModel)]="assignedWork"
                                                        readonly />
                                                </div>
                                                <div class="flgrow" *ngIf="assignedWork==null">
                                                    <input type="text" class="form-control" readonly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4 col-lg-2">
                                    <div class="row">
                                        <div class="col">
                                            <label translate>lblWorkOrderNo</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="">
                                                <div class="flgrow">
                                                    <ng-container
                                                        *ngIf="WoSelect &&  (stampOutButton || stampOutOverTimeButton) && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseWoSelect">
                                                        <ng-select placeholder="{{ 'lblSelectWorkOrder' | translate }}"  [(ngModel)]="selectedWO" [clearable]="false"
                                                            (change)="selectedWorkOrder($event)" (keyup.enter)="selectedWorkOrder($event)">
                                                            <ng-option *ngFor="let item of workOrderList" [value]="item.workOrderNumber">
                                                                {{item.workOrderNumber}}
                                                            </ng-option>
                                                        </ng-select>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4 col-lg-2">
                                    <div class="flgrow">
                                        <label translate>lblSelectJob</label>
                                        <ng-container
                                            *ngIf="WoSelect && selectedWO && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseJobSelect">
                                            <select [(ngModel)]="selectedJob" class="form-control"
                                                (change)="selectJob($event.target.value)">
                                                <option [ngValue]="null" selected translate disabled>lblSelectJob
                                                </option>
                                                <option *ngFor="let item of jobList" [(ngValue)]="item.id">
                                                    {{item.description}}
                                                </option>
                                            </select>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-4 col-lg-2" *ngIf="isJobDetailsTimerFeature">
                                    <div class="flgrow">
                                        <label translate>lblSelectJobDetail</label>
                                        <ng-container
                                            *ngIf="WoSelect && selectedWO && selectedJob && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseJobDetailsSelect">
                                            <select [(ngModel)]="selectedJobDetail" class="form-control"
                                            (change)="selectJobDetail($event.target.value)">
                                                <option [ngValue]="null" selected translate disabled>lblSelectJobDetail
                                                </option>
                                                <option *ngFor="let item of jobDetailsList" [(ngValue)]="item.id">
                                                    {{item.description}}
                                                </option>
                                            </select>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-6 d-flex">
                                    <ng-container
                                    *ngIf="workOrderNumber?.length > 0 && (stampOutButton || stampOutOverTimeButton) && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseJobStartBtn">
                                    <div class="date d-flex" >
                                        <ngb-timepicker style="max-width: 90px;" [(ngModel)]="startTime" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                        <button class=" btn rounded-pill btn-gray gry" aria-label="Center Align" style="height: 30px;margin-top: 17px;" 
                                        type="button" translate (click)="onWOStartButton(startTime)">lblStart</button>
                                    </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="workOrderNumber?.length > 0 && (stampOutButton || stampOutOverTimeButton) && woStopButton && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseJobStopBtn">
                                        <div class="date d-flex ">
                                            <ngb-timepicker style="max-width: 90px;" [(ngModel)]="stopTime" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                            <button class=" btn rounded-pill btn-gray gry" aria-label="Center Align" style="height: 30px;margin-top: 17px;" 
                                            type="button" translate (click)="onWOStopButton(stopTime)">lblStop</button>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="workOrderNumber?.length > 0 && woSummaryButton; else loadElseWoSummaryBtn">
                                        <button class="btn rounded-pill btn-gray gry" aria-label="Center Align" style="height: 30px;margin-top: 17px;" 
                                            type="button" translate
                                            (click)="onWOSummaryButton(woSummary)">lblWorkOrderSummary</button>
                                    </ng-container>
                                </div>
                                <div class="col-2 mt-3">
                                    <div class="flgrow">
                                        <label translate>lblSelectTimeCode</label>
                                        <ng-container *ngIf="stampOutButton || stampOutOverTimeButton; else loadElseTimeCodeSelect">
                                            <select class="form-control" [(ngModel)]="selectedTc"
                                                (change)="selectedTimeCode($event.target.value)">
                                                <option selected [value]="0" translate disabled>lblSelectTimeCode
                                                </option>
                                                <option *ngFor="let timeCode of timeCodeLangList"
                                                    [ngValue]="timeCode.Id" [selected]="timeCodeId==timeCode.Id">
                                                    {{timeCode.Code}}-{{timeCode.Description}}
                                                </option>
                                            </select>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-2 mt-3 d-flex">
                                    <ng-container
                                        *ngIf="(stampOutButton || stampOutOverTimeButton) && timeCodeStart && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseTimeCodeStartBtn">
                                        <div class="date d-flex" >
                                            <ngb-timepicker style="max-width: 90px;" [(ngModel)]="timeCodeStartTime" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                            <button class="btn rounded-pill btn-gray gry" aria-label="Center Align" style="height: 30px;margin-top: 17px;"
                                            (click)="timeCodeStartClick(timeCodeStartTime)" type="button" translate>lblSet</button>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="(stampOutButton || stampOutOverTimeButton) && timeCodeStop && (userRoleRightsDetails.canEdit || userRoleRightsDetails.canAdd); else loadElseTimeCodeStopBtn">
                                        <div class="date d-flex" >
                                        <ngb-timepicker style="max-width: 90px;" [(ngModel)]="timeCodeStopTime" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                        <button class="btn rounded-pill btn-gray gry" aria-label="Center Align" style="height: 30px;margin-top: 17px;"
                                            (click)="timeCodeStopClick(timeCodeStopTime)" type="button" translate>lblStop</button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="row mt20">
                            <div class="c12">
                                <div class="table-responsive tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <tr>
                                                <th scope="col" translate>lblTimerType</th>
                                                <th scope="col" translate>lblTimeCode</th>
                                                <th scope="col" translate>lblTimeFrom</th>
                                                <th scope="col" translate>lblTimeTo</th>
                                                <th scope="col" translate>lblReason</th>
                                                <th scope="col" translate>lblAction</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="timeCodeDetails?.length>0; else load_NotFound_Template">
                                                <tr *ngFor="let item of timeCodeDetails; let i=index">
                                                    <td translate> {{item.timerType}}</td>
                                                    <td>
                                                        <div *ngIf="item.timeCodeEn!=null">
                                                            {{item.timeCodeEn}}-{{item.descriptionEn}}
                                                        </div>
                                                        <div *ngIf="item.timeCodeNo!=null">
                                                            {{item.timeCodeNo}}-{{item.descriptionNo}}
                                                        </div>
                                                        <div *ngIf="item.timerTypeId==2">
                                                            {{item.workOrederNo}}
                                                        </div>
                                                        <div *ngIf="item.timerTypeId==3">
                                                            {{item.workOrederNo}}-{{item.description}}</div>
                                                        <div *ngIf="item.timerTypeId==4">
                                                                {{item.workOrederNo}}-{{item.jobDetailDescription}}</div>
                                                    </td>
                                                    <td>
                                                        {{item.startDateTime | date:'shortDate' }}
                                                        {{item.startDateTime | date:'HH:mm:ss' }}
                                                    </td>
                                                    <td>
                                                        <div *ngIf="item.endTime">
                                                            {{item.endDateTime | date:'shortDate' }}
                                                            {{item.endDateTime | date:'HH:mm:ss' }}
                                                        </div>
                                                        <div *ngIf="item.endTime==null">-</div>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight style="max-width: 300px" class="d-inline-block text-truncate text-truncate--2" [result]="item.reason"  [ngbTooltip]="tipContent" 
                                                        tooltipClass="custom-revert"></ngb-highlight>
                                                        
                                                        <div *ngIf="item.reason == null">-</div>

                                                        <ng-template #tipContent>
                                                            <ngb-highlight [result]="item.reason"></ngb-highlight>
                                                          </ng-template>
                                                    </td>
                                                    <td>
                                                        <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                                                        (click)="EditTimerDetails(summaryContent,item)">
                                                        <em class="fas fa-pencil-alt fa-lg"></em>
                                                        </a>
                                                        <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                                        (click)="DeleteTimerDetails(item)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #load_NotFound_Template>
                                                <tr>
                                                    <td colspan="8" translate>lblNoRecordsFound</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #content let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblViewSummary</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">
                ×
            </span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="table-responsive">
            <table class="tablest1">
                <thead>
                    <tr>
                        <th style="width: 20%" scope="col" translate>lblTimeCode</th>
                        <th style="width: 20%" scope="col"><span translate>lblTime</span> &nbsp;(<span
                                translate>lblhr</span>)</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="summaryList?.length>0; else load_NotFound_Template">
                        <tr *ngFor="let summaryLists of summaryList; let i=index">
                            <td>
                                <ngb-highlight [result]="summaryLists.timeCodeName">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="getTime(summaryLists.totalTime)">
                                </ngb-highlight>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #load_NotFound_Template>
                        <tr>
                            <td colspan="8" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary mr-sm-2 mb-1" type="button" aria-label="Center Align"
            (click)="modal.dismiss('Cross click')" translate>
            lblClose
        </button>
    </div>
</ng-template>
<ng-template #woSummary let-modal>
    <div>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title" translate>lblWorkOrderSummary</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">
                    ×
                </span>
            </button>
        </div>
        <div class="modal-body table-responsive p-0">
            <div class="col-12 p-0">
                <table class="tablest1">
                    <thead class="stick-header">
                        <tr>
                            <th scope="col" translate>lblDetails</th>
                            <th scope="col" translate>lblStampIn</th>
                            <th scope="col" translate>lblStampOut</th>
                            <th scope="col" translate>lblDuration</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="workOrderSummaryList?.length>0; else load_NotFound_Template">
                            <tr *ngFor="let item of workOrderSummaryList; let i=index">
                                <td>
                                    <div *ngIf="item.jobDescription">
                                        {{item.workOrderNo}}-{{item.jobDescription}}</div>
                                    <div *ngIf="item.jobDescription==null">{{item.workOrderNo}}</div>
                                </td>
                                <td>
                                    {{item.startTime}}
                                </td>
                                <td>
                                    <div *ngIf="item.endTime">
                                        {{item.endTime}}
                                    </div>
                                    <div *ngIf="item.endTime==null">-</div>
                                </td>
                                <td>
                                    <ngb-highlight [result]="item.duration">
                                    </ngb-highlight>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #load_NotFound_Template>
                            <tr>
                                <td colspan="4" class="text-center" translate>lblNoRecordsFound</td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary btn-md" aria-label="Center Align" type="button"
                (click)="modal.dismiss('Cross click')" translate>
                lblClose
            </button>
        </div>
    </div>
</ng-template>
<ng-template #summaryContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblSummary
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <form [formGroup]="woSummaryform">
            <div class="row">
                <div class="col-2">
                    <label class="text mt-4 ml-3" for="timefrom" translate>
                        lblTimeFrom <strong class="mlt6 required"> : </strong>
                    </label>
                </div>
                <div class="col-3">
                    <div class="lbl-info  mt-4 mb-2">
                        <div class="d-flex align-items-center">
                            <div class="lbl-info date mr-3">
                                <input formControlName="timefrom" class="form-control datePicker width100force" appAfDatepicker [ngModelOptions]="{standalone: true}"
                                  [startDate]="'2011/01/01'" [dateTime]="false"  [(ngModel)]="FromDate" [disableNextMonthDates]="true"
                                  [isOnlyTime]="false" [endDate]="today"
                                  >
                                <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="date iconfix ml-4 ">
                        <ngb-timepicker [(ngModel)]="FromTimeObj" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-2">
                    <label class="text mt-4 ml-3" for="timeto" translate>
                        lblTimeTo <strong class="mlt6 required"> :  </strong>
                    </label>
                </div>
                <div class="col-3">
                    <div class="lbl-info  mt-4 mb-2">
                        <div class="d-flex align-items-center">
                            <div class="lbl-info date mr-3">
                                <input formControlName="timeto" class="form-control datePicker width100force" appAfDatepicker [ngModelOptions]="{standalone: true}"
                                  [startDate]="'2011/01/01'" [dateTime]="false"  [(ngModel)]="TimeToDate" [disableNextMonthDates]="true"
                                  [isOnlyTime]="false" [endDate]="today"
                                  >
                                <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="date iconfix ml-4 ">
                        <ngb-timepicker [(ngModel)]="ToTimeObj" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                    </div>
                </div>
            </div>
            <div class="row ml-2 mr-5">
                <label for="comment"><span translate>lblReason</span><strong class="mlt6 required" style="color: red;">
                        *</strong></label>
                <textarea class="form-control" name="textDescription" maxlength="500" formControlName="reason" [(ngModel)]="summaryReason"
                    required> </textarea>

                    <div *ngIf="frm.reason.touched && (frm.reason.errors?.required)"
                    class="help-block mt-1 text-danger" translate>
                 <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                 lblReasonRequired
               </div>
            </div>
            <div *ngIf="!woSummaryform.controls.timeto?.valid && (woSummaryform.controls.timeto?.dirty || woSummaryform.controls.timeto?.touched)" class="help-block text-danger">
                <span translate>lblTimeToRequired</span>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md" (click)="EditSummaryDetails()"
            [disabled]="!woSummaryform.valid" translate><em class="far fa-save font15 align-top mr-2"></em>lblSave</button>
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')" translate><em
                class="far fa-times-circle font15 align-top mr-2"></em>lblCancel</button>
    </div>
    </ng-template>

<!-- Load Else Contents -->
<ng-template #loadElseWoSelect>
    <select class="form-control" [(ngModel)]="selectedWO" [disabled]="true">
        <option [ngValue]="null" selected translate disabled>
            lblSelectWorkOrder</option>
        <option *ngFor="let item of workOrderList" [(ngValue)]="item.workOrderNumber" [selected]="selectedWO==item.workOrderNumber">
            {{item.workOrderNumber}}
        </option>
    </select>
</ng-template>
<ng-template #loadElseJobSelect>
    <select [(ngModel)]="selectedJob" class="form-control" [disabled]="true">
        <option [ngValue]="null" selected translate disabled>lblSelectJob
        </option>
        <option *ngFor="let item of jobList" [(ngValue)]="item.id" [selected]="selectedJob==item.id">
            {{item.description}}
        </option>
    </select>
</ng-template>
<ng-template #loadElseJobDetailsSelect>
    <select [(ngModel)]="selectedJobDetail" class="form-control" [disabled]="true">
        <option [ngValue]="null" selected translate disabled>lblSelectJobDetail
        </option>
        <option *ngFor="let item of jobDetailsList" [(ngValue)]="item.id" [selected]="selectedJobDetail==item.id">
            {{item.description}}
        </option>
    </select>
</ng-template>
<ng-template #loadElseJobStartBtn>
    <div class="date d-flex">
        <ngb-timepicker style="max-width: 90px;"  [(ngModel)]="startTime" [disabled]="true" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
        <button class=" btn rounded-pill btn-gray gry" style="height: 30px;margin-top: 17px;"  aria-label="Center Align" type="button" translate
        [disabled]="true">lblStart</button>
    </div>
</ng-template>
<ng-template #loadElseJobStopBtn>
    <div class="date d-flex">
        <ngb-timepicker style="max-width: 90px;" [(ngModel)]="stopTime" [disabled]="true" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
        <button class=" btn rounded-pill btn-gray gry" style="height: 30px;margin-top: 17px;" aria-label="Center Align" type="button" translate
        [disabled]="true">lblStop</button>
    </div>
</ng-template>
<ng-template #loadElseWoSummaryBtn>
    <button class=" btn rounded-pill btn-gray gry" style="height: 30px;margin-top: 17px;" aria-label="Center Align" type="button" translate
        [disabled]="true">lblWorkOrderSummary</button>
</ng-template>
<ng-template #loadElseTimeCodeSelect>
    <select [disabled]="true" class="form-control" [(ngModel)]="selectedTc">
        <option selected [value]="0" translate disabled>lblSelectTimeCode
        </option>
        <option *ngFor="let timeCode of timeCodeLangList" [ngValue]="timeCode.Id">
            {{timeCode.Code}}-{{timeCode.Description}}
        </option>
    </select>
</ng-template>
<ng-template #loadElseTimeCodeStartBtn>
    <div class="date d-flex">
        <ngb-timepicker style="max-width: 90px;" [(ngModel)]="timeCodeStartTime" [disabled]="true" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
        <button class="btn rounded-pill btn-gray gry" aria-label="Center Align" [disabled]="true" type="button" style="height: 30px;margin-top: 17px;"
            translate>lblSet</button>
    </div>
</ng-template>
<ng-template #loadElseTimeCodeStopBtn>
    <div class="date d-flex">
        <ngb-timepicker style="max-width: 90px;" [(ngModel)]="timeCodeStopTime" [disabled]="true" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
        <button class="btn rounded-pill btn-gray gry" aria-label="Center Align" [disabled]="true" type="button" style="height: 30px;margin-top: 17px;"
        translate>lblStop</button>
    </div>
</ng-template>